import { useState } from "react";
import { QueryObserverBaseResult, useMutation } from "react-query";
import { GroupType, putScoring } from "../../../api/admin/score";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { SEdit, STable } from "../../../styles/AdminSearchScore";
import { Button } from "../../Button";
import { ScoreType } from "../AdminSearchScore";
import { useTranslation } from "react-i18next";
import SaveIcon from "../../../assets/img/icons/save.svg";
import CancelIcon from "../../../assets/img/icons/cancel.svg";
import MinusIcon from "../../../assets/img/icons/minus.svg";
import PlusIcon from "../../../assets/img/icons/plus.svg";

type ScoringTableProps = {
	group: GroupType;
	score: ScoreType;
	refetch: QueryObserverBaseResult["refetch"];
};

const MAX_SCORE = 100;

export const ScoreTable = (props: ScoringTableProps) => {
	const { score, refetch, group } = props;

	const { t } = useTranslation();

	const [newScore, setNewScore] = useState(score.boost);

	const { axiosPrivate } = useAxiosPrivate();
	const { mutate } = useMutation(putScoring, {
		onSuccess: () => refetch(),
	});

	const currentScoreSum = Object.values(score.boost).reduce((a, b) => a + b);
	const newScoreSum = Object.values(newScore).reduce((a, b) => a + b);

	const handleScore = (name: string, type: "increment" | "decrement") => {
		switch (type) {
			case "decrement":
				setNewScore((prev) => ({ ...prev, [name]: prev[name] - 1 }));
				break;
			case "increment":
				setNewScore((prev) => ({ ...prev, [name]: prev[name] + 1 }));
				break;
		}
	};

	const entries = Object.entries(score.boost);
	const mapped = entries?.map((entry) => (
		<tr key={entry[0]}>
			<td>{t(`${entry[0]}`)}</td>
			<td>{entry[1]}</td>
			<td>
				<SEdit>
					<button onClick={() => handleScore(entry[0], "decrement")} disabled={newScore[entry[0]] < 1}>
						<img src={MinusIcon} alt="decrese" />
					</button>
					<span>{newScore[entry[0]]}</span>
					<button onClick={() => handleScore(entry[0], "increment")} disabled={MAX_SCORE === newScoreSum}>
						<img src={PlusIcon} alt="increase" />
					</button>
				</SEdit>
			</td>
		</tr>
	));

	return (
		<>
			<STable>
				<thead>
					<tr>
						<td>Factor</td>
						<td>Relevance</td>
						<td>Update</td>
					</tr>
				</thead>
				<tbody>{mapped}</tbody>
				<tfoot>
					<tr>
						<td>Total:</td>
						<td>{currentScoreSum}</td>
						<td>{newScoreSum}</td>
					</tr>
				</tfoot>
			</STable>
			<Button
				icon={CancelIcon}
				onClick={() => {
					setNewScore(score.boost);
				}}
			>
				Discard
			</Button>
			<Button icon={SaveIcon} disabled={newScoreSum < MAX_SCORE} onClick={() => mutate({ axiosPrivate, group, data: newScore })}>
				Save
			</Button>
		</>
	);
};
